// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken } from 'firebase/messaging';

// Firebase config
const firebaseConfig = {
  apiKey: 'AIzaSyBZNWT3ZsM6hEtQvmU9oj2p8t2cqJBPi7g',
  authDomain: 'ktc-framework.firebaseapp.com',
  projectId: 'ktc-framework',
  storageBucket: 'ktc-framework.firebasestorage.app',
  messagingSenderId: '593634173990',
  appId: '1:593634173990:web:1872f917f68e316cef72e7',
  measurementId: 'G-S7MQTMG271',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

// Initialize messaging
export const messaging = getMessaging(app);

export async function requestFCMToken() {
  try {
    const existingToken = localStorage.getItem('fcm_token');

    if (existingToken) {
      console.log('Using saved token:', existingToken);
      return existingToken;
    }

    await Notification.requestPermission();

    const newToken = await getToken(messaging, {
      vapidKey:
        'BKKfld5c2R5z4aLz-pSnW9T1OUwmMlBUCqQ0EfBr6vpDU95ZTIP99cnymOe5VDggWgu_jkSmvmYnVpVdbpiQCsw',
    });

    if (newToken) {
      localStorage.setItem('fcm_token', newToken);
      console.log('New FCM Token:', newToken);
      return newToken;
    }
  } catch (err) {
    console.error('Error getting FCM token:', err);
  }
}
